import BridgeEvent, { BridgeEvents } from "./events.js";
export class WebviewBridgeEmitter {
  constructor(sender) {
    this.sender = void 0;
    this.share = shareObject => {
      this.sender.send(new BridgeEvent(BridgeEvents.SHARE, {
        detail: shareObject
      }));
    };
    this.updateViewState = (state, error = null) => {
      this.sender.send(new BridgeEvent(BridgeEvents.UPDATE_VIEW_STATE, {
        detail: {
          state,
          error
        }
      }));
    };
    this.closeScreen = () => {
      this.sender.send(new BridgeEvent(BridgeEvents.CLOSE_SCREEN));
    };
    this.playAudio = (type, content) => {
      this.sender.send(new BridgeEvent(BridgeEvents.PLAY_AUDIO, {
        detail: {
          type,
          content
        }
      }));
    };
    this.stopAudio = () => {
      this.sender.send(new BridgeEvent(BridgeEvents.STOP_AUDIO));
    };
    this.muteAudio = isMuted => {
      this.sender.send(new BridgeEvent(BridgeEvents.MUTE_AUDIO, {
        detail: {
          isMuted
        }
      }));
    };
    this.onPageChanged = () => {
      this.sender.send(new BridgeEvent(BridgeEvents.ON_PAGE_CHANGED));
    };
    this.openDeepLink = deepLink => {
      this.sender.send(new BridgeEvent(BridgeEvents.OPEN_DEEP_LINK, {
        detail: deepLink
      }));
    };
    this.sendCastMessage = (message, namespace) => {
      this.sender.send(new BridgeEvent(BridgeEvents.SEND_CAST_MESSAGE, {
        detail: {
          message,
          namespace
        }
      }));
    };
    this.showCastIcon = () => {
      this.sender.send(new BridgeEvent(BridgeEvents.SHOW_CAST_ICON));
    };
    this.hideCastIcon = () => {
      this.sender.send(new BridgeEvent(BridgeEvents.HIDE_CAST_ICON));
    };
    this.openCastDialog = () => {
      this.sender.send(new BridgeEvent(BridgeEvents.OPEN_CAST_DIALOG));
    };
    this.sender = sender;
  }
}
//# sourceMappingURL=WebviewBridgeEmitter.js.map